export const fieldOptions = [
    {
        name: 'optional',
        fa_name: 'اختیاری',
        value: 1,
    },
    {
        name: 'required',
        fa_name: 'اجباری',
        value: 2,
    }
]


export const fieldOptionsConstants = {
    OPTIONAL: 1,
    REQUIRED: 2,
}
